import React, { useEffect, useState } from "react";
import $ from "jquery";
import { NavBar, Spinner } from "../components";
import { Helmet } from "react-helmet-async";
import { Footer } from "../layouts";
import Card from "../components/card";
import { useParams } from "react-router";
import axios from "axios";

const CategoryDetails = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [spinColor, setSpinColor] = useState("success");

  useEffect(() => {
    let tim2 = setTimeout(() => {
      setIsLoading(false);
    }, 4000);

    return () => {
      clearTimeout(tim2);
    };
  }, []);

  return (
    <>
      {isLoading ? (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
              width: "100%",
              position: "fixed",
              left: 0,
              top: 0,
            }}
          >
            <Spinner grow color={spinColor} size={5} />
          </div>
        </>
      ) : (
        <Main />
      )}

      <Helmet>
        <link
          rel="stylesheet"
          href="../assets/css/bootstrap/icons/bootstrap-icons.css"
        />
        <link
          rel="stylesheet"
          href="../assets/css/hs/mega-menu/mega-menu.min.css"
        />
        <link rel="stylesheet" href="../assets/css/_theme.css" />

        <script
          defer
          asyn
          src="../assets/js/bootstrap/bootstrap.bundle.min.js"
        ></script>
        <script defer asyn src="../assets/js/hs/go-to/goto.min.js"></script>
        <script defer asyn src="../assets/js/prism/prism.js"></script>
        <script
          defer
          asyn
          src="../assets/js/hs/show-animation/show-animation.min.js"
        ></script>
        <script
          defer
          asyn
          src="../assets/js/hs/mega-menu/mega-menu.min.js"
        ></script>
        <script defer asyn src="../assets/js/hs/header/header.min.js"></script>
        <script defer asyn src="../assets/js/fslightbox/index.js"></script>
        <script defer asyn src="../assets/js/theme.min.js"></script>
      </Helmet>
    </>
  );
};

export default CategoryDetails;

const Main = () => {
  const [companies, setCompanies] = useState(null);
  const [countries, setCountries] = useState(null);
  const [companyType, setCompanyType] = useState(null);
  const [category, setCategory] = useState(null);
  const { id } = useParams();
  const decodedId = atob(id);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [
          companiesResponse,
          countriesResponse,
          categoriesResponse,
          companyTypeResponse,
        ] = await Promise.all([
          axios
            .get(
              `https://abn.happynessarl.com/api/v1/get-company-by-subcategory/${decodedId}`
            )
            .then((response) => response.data),
          axios
            .get(`https://abn.happynessarl.com/api/v1/country/company`)
            .then((response) => response.data),
          axios
            .get(`https://abn.happynessarl.com/api/v1/categories`)
            .then((response) => response.data),
          axios
            .get(`https://abn.happynessarl.com/api/v1/get/type`)
            .then((response) => response.data),
        ]);

        setCompanies(companiesResponse);
        setCountries(countriesResponse);
        setCategory(categoriesResponse);
        setCompanyType(companyTypeResponse);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (decodedId) {
      fetchData();
    }
    const script = `
    new HSGoTo('.js-go-to');
    new HSHeader('#header').init();
    new HSMegaMenu('.js-mega-menu', {"desktop": {"position": "left"}});
`;

    $("body").append(`<script className="homescript">${script}</script>`);

    return () => {
      $(".homescript").remove();
    };
  }, [decodedId]);

  const handleRadioChange = async (event, searchParam) => {
    const selectedValue = event.target.value;
    const apiUrl = "https://abn.happynessarl.com/api/v1/companies/search";
    const headers = {
      "Content-Type": "application/json",
    };

    try {
      const response = await axios.post(
        apiUrl,
        { [searchParam]: selectedValue },
        { headers }
      );

      if (response.status === 200) {
        setCompanies(response.data.data);
      } else {
        console.error(
          "Error searching for companies:",
          response.status,
          response.data
        );
      }
    } catch (error) {
      console.error("Error searching for companies:", error);
    }
  };

  return (
    <>
      <NavBar sub />
      <main>
        <div className="container content-space-t-lg-4 mt-2 content-space-b-2 content-space-b-lg-3">
          <div className="row">
            {countries === null &&
            companyType === null &&
            category === null &&
            companies === null ? (
              <div className="container text-center my-4">
                <Spinner grow={false} color={"success"} size={3} />
              </div>
            ) : (
              <>
                <div className="col-lg-3">
                  <h3 className="mb-3">Filters</h3>
                  <div className="d-flex flex-column gap-3">
                    {/* Countries */}
                    {countries?.data?.companyCountry && (
                      <div>
                        <h5>Countries</h5>
                        <div
                          className="category-container"
                          style={{ maxHeight: "350px", overflowY: "auto" }}
                        >
                          {Object.entries(countries.data.companyCountry).map(
                            ([key, value]) => (
                              <div
                                key={key}
                                className="d-flex align-items-center mb-2"
                              >
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="countries"
                                    value={value}
                                    onChange={(event) =>
                                      handleRadioChange(event, "pays")
                                    }
                                  />
                                  <label className="form-check-label">
                                    {value}
                                  </label>
                                </div>
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    )}

                    {/* Company Type */}
                    {companyType?.data?.companyType && (
                      <div>
                        <h5>Company Type</h5>
                        <div
                          className="category-container"
                          style={{ maxHeight: "350px", overflowY: "auto" }}
                        >
                          {Object.entries(companyType.data.companyType).map(
                            ([key, value]) => (
                              <div
                                key={key}
                                className="d-flex align-items-center mb-2"
                              >
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="company-type"
                                    value={value}
                                    onChange={(event) =>
                                      handleRadioChange(event, "type")
                                    }
                                  />
                                  <label className="form-check-label">
                                    {value}
                                  </label>
                                </div>
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    )}

                    {/* Category */}
                    {category.data.categories.length > 0 && (
                      <div>
                        <h5>Category</h5>
                        <div
                          className="category-container"
                          style={{ maxHeight: "350px", overflowY: "auto" }}
                        >
                          {category.data.categories.map((category) => (
                            <div
                              key={category.id}
                              className="d-flex align-items-center mb-2"
                            >
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="category"
                                  value={category.name}
                                  onChange={(event) =>
                                    handleRadioChange(event, "name")
                                  }
                                />
                                <label className="form-check-label">
                                  {category.name}
                                </label>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-9 mt-lg-0 mt-3">
                  {companies.status === "error" ? (
                    <div
                      className="card card border shadow-lg"
                      style={{ width: "100%" }}
                    >
                      <div className="card-body">An error occurred</div>
                    </div>
                  ) : companies.data?.company?.length > 0 ||
                    companies.length > 0 ? (
                    (companies.data?.company || companies).map((company) => (
                      <div key={company.id} className="mb-3">
                        <Card
                          companyId={btoa(company.id)}
                          companyLogo={company.logo}
                          companyWebsite={company.site_web}
                          companyName={company.name}
                          companyLocation={company.pays}
                          companyDescription={company.description}
                        />
                      </div>
                    ))
                  ) : (
                    <div
                      className="card card border shadow-lg"
                      style={{ width: "100%" }}
                    >
                      <div className="card-body">No Company found</div>
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </main>
      <Footer sub />
    </>
  );
};
